"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7792],{

/***/ 14774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);




// https://developers.google.com/optimize/devguides/experiments
var BaseLayout = function(param) {
    var _title = param.title, title = _title === void 0 ? "" : _title, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col mx-auto bg-black",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                        children: [
                            title,
                            " Ladder"
                        ]
                    }, "title"),
                     true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        src: "https://www.googleoptimize.com/optimize.js?id=".concat("OPT-PFHPRXT")
                    }) : 0,
                     true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        src: "https://www.googletagmanager.com/gtag/js?id=".concat("UA-147635647-2")
                    }) : 0,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_2___default()), {
                id: "GA",
                dangerouslySetInnerHTML: {
                    __html: "\n              window.dataLayer = window.dataLayer || [];\n              function gtag(){dataLayer.push(arguments);}\n              gtag('js', new Date());\n              gtag('config', '".concat("UA-147635647-2", "');\n          ")
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_2___default()), {
                id: "_clarity",
                dangerouslySetInnerHTML: {
                    __html: '\n          (function(c,l,a,r,i,t,y){\n            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};\n            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;\n            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);\n        })(window, document, "clarity", "script", "cgcxtev9ab");\n          '
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: '\n            !function (w, d, t) {\n              w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};\n            \n              ttq.load(\'C97L7M3C77U37LFVKAFG\');\n              ttq.page();\n            }(window, document, \'ttq\');\n          '
                }
            }),
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BaseLayout);


/***/ }),

/***/ 23333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Footer; },
/* harmony export */   "n": function() { return /* binding */ SocialItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lib_sitemap_links__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49099);
/* harmony import */ var _action__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1191);
/* harmony import */ var _nav__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44401);









var NavReplica = function(param) {
    var linksToFilter = param.linksToFilter;
    var links = [
        {
            id: "WWOD",
            title: "Free Workout Of The Day",
            href: "/workout/today",
            event: {
                action: "WWOD_page__clicked",
                category: "footer"
            }
        },
        {
            id: "pricing",
            title: "Pricing",
            href: "/pricing",
            event: {
                action: "pricing_page__clicked",
                category: "footer"
            }
        },
        {
            id: "ladder_shop",
            title: "Ladder Shop",
            href: "https://shop.joinladder.com",
            event: {
                action: "ladder_shop_clicked",
                category: "footer"
            },
            rel: "noreferrer",
            target: "_blank"
        }, 
    ];
    var filteredLinks = links.filter(function(param) {
        var id = param.id;
        return !linksToFilter.includes(id);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            borderColor: "#6D6D6D"
        },
        className: "flex items-center justify-between py-2 mb-4 space-x-4 border-b border-white lg:mb-8",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nav__WEBPACK_IMPORTED_MODULE_4__/* .Logo */ .T, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "hidden lg:block",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex items-center space-x-6 text-sm ",
                    children: [
                        filteredLinks.map(function(_param) {
                            var id = _param.id, title = _param.title, href = _param.href, event = _param.event, res = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
                                "id",
                                "title",
                                "href",
                                "event"
                            ]);
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_action__WEBPACK_IMPORTED_MODULE_3__/* .LinkAction */ .N, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                                href: href,
                                className: "uppercase hover:opacity-80",
                                event: event
                            }, res), {
                                children: title
                            }), id);
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_action__WEBPACK_IMPORTED_MODULE_3__/* .Action */ .a, {
                            at: "footer.cta",
                            event: {
                                action: "find_my_plan_cta_clicked"
                            },
                            className: "hidden px-6 py-3 text-black rounded-full md:text-sm cta lg:flex bg-volt"
                        })
                    ]
                })
            })
        ]
    });
};
var StayConnected = function() {
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("h4", {
                className: "font-bold",
                children: "LETS STAY CONNECTED"
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "block mb-4 text-sm",
                children: "Subscribe to stay tuned for latest updates. Let's do it!"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex w-full space-x-4",
                children: [
                    /*#__PURE__*/ _jsx("input", {
                        className: "flex-1 px-2 py-2 lg:px-3 lg:py-4 ",
                        placeholder: "Enter your email address",
                        style: {
                            background: "#212121"
                        }
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        "aria-label": "subscribe",
                        className: "px-4 py-2 text-sm border border-white lg:px-6 lg:py-4 md:text-base cta",
                        children: "Subscribe"
                    })
                ]
            })
        ]
    });
};
var SocialItem = function(param) {
    var _urlPrefix = param.urlPrefix, urlPrefix = _urlPrefix === void 0 ? "https://" : _urlPrefix, urlText = param.urlText, url = param.url, imageName = param.imageName, invert = param.invert, _showName = param.showName, showName = _showName === void 0 ? true : _showName;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
        className: "flex space-x-3 center",
        target: "_blank",
        rel: "noreferrer",
        href: "".concat(urlPrefix).concat(url),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                alt: imageName,
                className: "block w-6 h-6 text-white",
                style: invert && {
                    filter: "invert(100%)"
                },
                src: "https://media.teams.joinladder.com/website/icons/social/".concat(imageName, ".svg")
            }),
            showName ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "hidden lg:flex",
                children: urlText || url
            }) : null
        ]
    });
};
var QRCode = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "hidden px-6 py-4 space-x-6 border border-white lg:flex rounded-xl",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                alt: "qr code",
                className: "w-28 h-28",
                src: "/assets/footer-qr.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    alt: "download on the app store",
                    src: "/assets/download-on-appstore.svg"
                })
            })
        ]
    });
};
var Footer = function(param) {
    var _linksToFilter = param.linksToFilter, linksToFilter = _linksToFilter === void 0 ? [] : _linksToFilter;
    var filteredLinks = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
        if (!(linksToFilter === null || linksToFilter === void 0 ? void 0 : linksToFilter.length)) return _lib_sitemap_links__WEBPACK_IMPORTED_MODULE_2__/* .links */ .O;
        var filtered = _lib_sitemap_links__WEBPACK_IMPORTED_MODULE_2__/* .links.filter */ .O.filter(function(param) {
            var id = param.id;
            return !linksToFilter.includes(id);
        });
        return filtered.map(function(_param, i) {
            var items = _param.items, res = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
                "items"
            ]);
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, res), {
                items: items.filter(function(param) {
                    var id = param.id;
                    return !linksToFilter.includes(id);
                })
            });
        });
    }, [
        linksToFilter
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "px-4 pt-16 pb-16 mx-auto text-white lg:px-12 xl:px-24",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NavReplica, {
                linksToFilter: linksToFilter
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col justify-between mb-4 lg:mb-8 lg:space-x-16 xl:space-x-24 lg:flex-row",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(QRCode, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex flex-col flex-1 max-w-xl mb-12 lg:space-x-6 md:flex-row lg:mb-0",
                        children: filteredLinks.map(function(param) {
                            var title = param.title, items = param.items;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "w-full mb-12",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "mb-4 text-lg leading-8 text-white lg:leading-tight md:mb-8 lg:text-xl heading",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                        className: "flex flex-col flex-wrap space-y-4",
                                        children: items.map(function(_param, i) {
                                            var title = _param.title, href = _param.href, pending = _param.pending, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
                                                "title",
                                                "href",
                                                "pending"
                                            ]);
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                                                    href: href
                                                }, props), {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)("opacity-90 hover:opacity-100", {
                                                                "opacity-80": pending
                                                            }),
                                                            children: title
                                                        }),
                                                        pending ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "px-1 mx-2 text-xs font-medium text-black rounded-full bg-volt",
                                                            children: "Coming soon"
                                                        }) : null
                                                    ]
                                                }))
                                            }, i);
                                        })
                                    })
                                ]
                            }, title);
                        })
                    }),
                    !linksToFilter.includes("social") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-row items-start space-x-6 lg:space-y-6 lg:space-x-0 lg:flex-col",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SocialItem, {
                                url: "tiktok.com/@joinladder",
                                imageName: "tiktok",
                                invert: true
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SocialItem, {
                                url: "instagram.com/joinladder",
                                imageName: "instagram"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SocialItem, {
                                url: "facebook.com/joinladder",
                                imageName: "facebook"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SocialItem, {
                                url: "support@joinladder.com",
                                urlPrefix: "mailto:",
                                imageName: "mail"
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex space-x-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        children: [
                            "\xa9 ",
                            new Date().getFullYear(),
                            " Ladder Technologies, Inc."
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: "|"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "https://joinladder.com/terms",
                        target: "_blank",
                        rel: "noreferrer",
                        children: "Terms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: "•"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "https://joinladder.com/privacy",
                        target: "_blank",
                        rel: "noreferrer",
                        children: "Privacy"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: "•"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "/sitemap",
                        children: "Sitemap"
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 55480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ HeadContent; }
/* harmony export */ });
/* unused harmony export favIconDevWrapper */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers_misc__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56554);



var favIconDevWrapper = function(value) {
    return "/fav/".concat(_helpers_misc__WEBPACK_IMPORTED_MODULE_2__/* .isDev */ .r8 ? "dev" : "prod", "/").concat(value);
};
var HeadContent = function(param) {
    var _title = param.title, title = _title === void 0 ? "Ladder" : _title, _description = param.description, description = _description === void 0 ? "Get stronger &amp; workout more. Free 7 day trial, no credit card needed!" : _description, _image = param.image, image = _image === void 0 ? "joinladder-og-image-2.png" : _image;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                test: "head",
                type: "image/x-icon",
                href: favIconDevWrapper("favicon.ico")
            }, "icon/image/x-icon"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "180x180",
                href: favIconDevWrapper("apple-touch-icon.png")
            }, "apple-touch-icon/180x180"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "32x32",
                href: favIconDevWrapper("favicon-32x32.png")
            }, "image/png/32x32"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "16x16",
                href: favIconDevWrapper("favicon-16x16.png")
            }, "image/png/16x16"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "manifest",
                href: "/site.webmanifest"
            }, "manifest"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "prefetch",
                href: "/assets/logo/white.png"
            }, "prefetch1"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "prefetch",
                href: "https://media.teams.joinladder.com/website/hero/mobile/main.png"
            }, "prefetch2"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "prefetch",
                href: "/assets/award-thing.svg"
            }, "prefetch3"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "prefetch",
                href: "https://media.teams.joinladder.com/website/hero/main.png"
            }, "prefetch4"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }, "title"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: title,
                property: "og:title"
            }, "og:title"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: title,
                property: "twitter:title"
            }, "twitter:title"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: description,
                name: "description"
            }, "description"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: description,
                property: "og:description"
            }, "og:description"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: description,
                property: "twitter:description"
            }, "twitter:description"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: "https://media.teams.joinladder.com/website/" + image,
                property: "og:image"
            }, "og:image"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: "https://media.teams.joinladder.com/website/" + image,
                property: "twitter:image"
            }, "twitter:image"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: "@joinladder",
                property: "twitter:site"
            }, "twitter:site"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: "summary_large_image",
                name: "twitter:card"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            })
        ]
    });
};


/***/ }),

/***/ 56554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D0": function() { return /* binding */ isLocal; },
/* harmony export */   "Xk": function() { return /* binding */ createDictionary; },
/* harmony export */   "Z0": function() { return /* binding */ isAuthenticIOS; },
/* harmony export */   "_v": function() { return /* binding */ sleep; },
/* harmony export */   "b9": function() { return /* binding */ limit; },
/* harmony export */   "fV": function() { return /* binding */ getValidDate; },
/* harmony export */   "fY": function() { return /* binding */ getCurrentDayOfWeekIndex; },
/* harmony export */   "gO": function() { return /* binding */ iOS; },
/* harmony export */   "r8": function() { return /* binding */ isDev; }
/* harmony export */ });
/* unused harmony exports timeToUtc, pluralize, validURL, sleepOld */
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42227);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52979);



var isDev = "development" !== "production";
var isLocal = "development" === "local";
var getCurrentDayOfWeekIndex = function() {
    var currentDay = new Date().toLocaleString("default", {
        weekday: "long"
    });
    return _lib_constants__WEBPACK_IMPORTED_MODULE_1__/* .daysOfWeekLong.indexOf */ .Y4.indexOf(currentDay);
};
function dateHasTimeZone(date) {
    try {
        return date.endsWith("Z") || date.includes("+");
    } catch (e) {
        console.error(e, date);
    }
}
function timeToUtc(date) {
    try {
        return new Date(date + (dateHasTimeZone(date) ? "" : "Z"));
    } catch (e) {
        console.error(e, date);
    }
}
function getValidDate(date) {
    if (!date) return;
    if ((0,lodash__WEBPACK_IMPORTED_MODULE_0__.isNumber)(date)) return (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Number(date));
    return typeof date === "string" ? timeToUtc(date) : date;
}
var limit = function(array, limitNumber) {
    if (!array || !(array === null || array === void 0 ? void 0 : array.length)) return array;
    if (typeof limitNumber !== "number") return array;
    return array.filter(function(_, i) {
        if (i <= limitNumber - 1) return true;
    });
};
function createDictionary(data) {
    var key = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "id";
    if (!(data === null || data === void 0 ? void 0 : data.length)) return {};
    var dictionary = {};
    data.map(function(n) {
        dictionary[n[key]] = n;
    });
    return dictionary;
}
var pluralize = function(count, word) {
    var suffix = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "s";
    if (count === 1) return word;
    return word + suffix;
};
function iOS() {
    var ref, ref1;
    return [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod", 
    ].includes(navigator === null || navigator === void 0 ? void 0 : navigator.platform) || // iPad on iOS 13 detection
    ((navigator === null || navigator === void 0 ? void 0 : (ref = navigator.userAgent) === null || ref === void 0 ? void 0 : (ref1 = ref.includes) === null || ref1 === void 0 ? void 0 : ref1.call(ref, "Mac")) && "ontouchend" in document);
}
function isAuthenticIOS() {
    var ref, ref1;
    if (typeof navigator === "undefined") return false;
    return [
        "iPad",
        "iPhone",
        "iPod"
    ].includes(navigator === null || navigator === void 0 ? void 0 : navigator.platform) || // iPad on iOS 13 detection
    ((navigator === null || navigator === void 0 ? void 0 : (ref = navigator.userAgent) === null || ref === void 0 ? void 0 : (ref1 = ref.includes) === null || ref1 === void 0 ? void 0 : ref1.call(ref, "Mac")) && "ontouchend" in document);
}
function validURL(str) {
    var res = str.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g);
    return res !== null;
}
var sleep = function(ms) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, ms);
    });
};
function sleepOld(milliseconds) {
    var timeStart = new Date().getTime();
    // eslint-disable-next-line no-constant-condition
    while(true){
        var elapsedTime = new Date().getTime() - timeStart;
        if (elapsedTime > milliseconds) {
            break;
        }
    }
}


/***/ }),

/***/ 35453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ renderSegmentSnippet; }
/* harmony export */ });
/* harmony import */ var _segment_snippet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72913);

var renderSegmentSnippet = function() {
    var apiKey = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "qcySYjUUoGTrtg3E2CdW0hfXepJo2tiL";
    var opts = {
        apiKey: apiKey,
        // note: the page option only covers SSR tracking.
        // Page.js is used to track other events using `window.analytics.page()`
        page: true
    };
    if (true) {
        return _segment_snippet__WEBPACK_IMPORTED_MODULE_0__/* .max */ .F(opts);
    }
    return _segment_snippet__WEBPACK_IMPORTED_MODULE_0__/* .min */ .V(opts);
};


/***/ }),

/***/ 49099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ links; }
/* harmony export */ });
var links = [
    {
        id: "pages",
        title: "Pages",
        items: [
            {
                id: "home",
                title: "Home",
                href: "/"
            },
            {
                id: "pricing",
                title: "Pricing",
                href: "/pricing"
            },
            {
                id: "WWOD",
                title: "Free Workout Of The Day",
                href: "/workout/today"
            },
            {
                id: "ladder_shop",
                title: "Ladder Shop",
                href: "https://shop.joinladder.com",
                target: "_blank",
                rel: "noreferrer"
            },
            {
                id: "plan",
                title: "Find Your Plan",
                href: "https://offers.joinladder.com/survey",
                target: "_blank",
                rel: "noreferrer"
            },
            {
                id: "blog",
                title: "Blog",
                href: "https://blog.joinladder.com",
                target: "_blank",
                rel: "noreferrer"
            },
            {
                id: "careers",
                title: "Careers",
                href: "https://ladder.breezy.hr",
                target: "_blank",
                rel: "noreferrer"
            }, 
        ]
    },
    {
        id: "teams",
        title: "Programs",
        items: [
            {
                title: "Body & Bell",
                href: "https://teams.joinladder.com/program/lauren",
                target: "_blank",
                rel: "noreferrer"
            },
            {
                title: "Boundless",
                href: "https://teams.joinladder.com/program/ben-greenfield",
                target: "_blank",
                rel: "noreferrer"
            },
            {
                title: "Crews Control",
                href: "https://teams.joinladder.com/program/andre-crews",
                target: "_blank",
                rel: "noreferrer"
            },
            {
                title: "ELEVATE",
                href: "https://teams.joinladder.com/program/elise",
                target: "_blank",
                rel: "noreferrer"
            },
            {
                title: "Maximus",
                href: "https://teams.joinladder.com/program/bobby-joe",
                target: "_blank",
                rel: "noreferrer"
            },
            {
                title: "Project Alpha",
                href: "https://teams.joinladder.com/program/sam-tooley",
                target: "_blank",
                rel: "noreferrer"
            },
            {
                title: "Team Resilient",
                href: "https://teams.joinladder.com/program/reign-neen",
                target: "_blank",
                rel: "noreferrer"
            },
            {
                title: "Team RX",
                href: "https://teams.joinladder.com/program/emily-rethwill",
                target: "_blank",
                rel: "noreferrer"
            },
            {
                title: "EMPWR",
                href: "https://teams.joinladder.com/program/courteney-fisher",
                target: "_blank",
                rel: "noreferrer"
            },
            {
                title: "Limitless",
                href: "https://teams.joinladder.com/program/kelly-matthews",
                target: "_blank",
                rel: "noreferrer"
            },
            {
                title: "Movewell",
                href: "https://teams.joinladder.com/program/nicole-rauch",
                target: "_blank",
                rel: "noreferrer"
            },
            {
                title: "Iconic",
                href: "https://teams.joinladder.com/program/sarah-ryan",
                target: "_blank",
                rel: "noreferrer"
            },
            {
                title: "Formation",
                href: "https://teams.joinladder.com/program/robin-b",
                target: "_blank",
                rel: "noreferrer"
            }, 
        ]
    }, 
];


/***/ })

}]);